import SectionHeader from "@/components/base/SectionHeader";
import CTAButton from "@/components/base/CTAButton";

const services = [
  {
    num: "01",
    title: "Websites",
    desc: "Professional websites that turn visitors into customers.",
    items: [
      "Corporate websites",
      "Business websites",
      "Landing pages",
      "E-commerce",
      "Website redesign",
      "SEO-ready websites",
      "Performance optimization",
    ],
    cta: "Build My Website",
    to: "/contact",
  },
  {
    num: "02",
    title: "Custom Software",
    desc: "Digital systems designed around the way your organization works.",
    items: [
      "Web applications",
      "Customer portals",
      "Management systems",
      "Dashboards",
      "Internal business tools",
      "Workflow systems",
      "API integrations",
    ],
    cta: "Build My Solution",
    to: "/contact",
  },
  {
    num: "03",
    title: "Automation & AI",
    desc: "Reduce repetitive work and make your business smarter.",
    items: [
      "Business process automation",
      "AI-powered features",
      "Intelligent workflows",
      "Data processing",
      "AI assistants",
      "API integrations",
      "Automated reporting",
    ],
    cta: "Automate My Business",
    to: "/contact",
  },
  {
    num: "04",
    title: "Digital Transformation",
    desc: "Turn manual processes into connected digital experiences.",
    items: [
      "Digital strategy",
      "Process digitization",
      "System integration",
      "Legacy process modernization",
      "Custom platforms",
      "Technology consulting",
    ],
    cta: "Discuss My Project",
    to: "/contact",
  },
];

export default function Services() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1280px]">
        <SectionHeader
          eyebrow="What We Build"
          title="From your first website to a complete digital platform, we build technology around your goals."
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((s) => (
            <div
              key={s.num}
              className="group rounded-lg border border-background-200 bg-background-50 p-7 md:p-8 transition-all duration-300 hover:border-primary-300 hover:-translate-y-1"
            >
              <div className="flex items-start justify-between">
                <h3 className="font-heading text-2xl font-bold text-foreground-950">
                  {s.title}
                </h3>
                <span className="font-heading text-3xl font-bold text-primary-200 group-hover:text-primary-500 transition-colors">
                  {s.num}
                </span>
              </div>
              <p className="mt-2 text-foreground-600 leading-relaxed">{s.desc}</p>

              <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2.5">
                {s.items.map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-2 text-sm text-foreground-700"
                  >
                    <i className="ri-check-line text-primary-500 mt-0.5"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-7">
                <CTAButton to={s.to} variant="ghost" icon="ri-arrow-right-line" className="px-0 font-semibold">
                  {s.cta}
                </CTAButton>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <CTAButton to="/services" variant="dark" icon="ri-arrow-right-line">
            Explore All Services
          </CTAButton>
        </div>
      </div>
    </section>
  );
}